import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SelectedRangeOption } from '@anytag/shared-types';
import { Form } from '@anytag/shared-atoms';
import { AsyncSearchInfluencerField, RangeDatePickerField, TextSearchField } from '@anytag/shared-molecules';
import { CampaignPostsDiscoveryFilterFormValues, CampaignPostsDiscoveryFilterFormKeys } from './schemaTypes';
import { AdvancedFilter } from './AdvancedFilter';

interface BasicFilterProps {
  onSubmit?: () => void;
}

export const BasicFilter = ({ onSubmit }: BasicFilterProps) => {
  const { t } = useTranslation();
  const { getValues } = useFormContext<CampaignPostsDiscoveryFilterFormValues>();

  const values = getValues();

  const isAllTime = !values.startDate && !values.endDate;
  const rangeList = [
    SelectedRangeOption.TODAY,
    SelectedRangeOption.LAST_SEVEN_DAYS,
    SelectedRangeOption.TODAY_TO_MONTH_AGO,
    SelectedRangeOption.THIS_MONTH,
    SelectedRangeOption.LAST_MONTH,
    SelectedRangeOption.CUSTOM,
    SelectedRangeOption.CLEAR
  ];

  return (
    <Form.Fields>
      <TextSearchField<CampaignPostsDiscoveryFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.Search by Campaign name, Content, Influencer name')}
      />
      <AsyncSearchInfluencerField<CampaignPostsDiscoveryFilterFormKeys>
        name="influencerIds"
        onSubmit={onSubmit}
        className="w-46 flex-none"
        multiple
      />
      <RangeDatePickerField<CampaignPostsDiscoveryFilterFormKeys>
        onSubmit={onSubmit}
        rangeList={rangeList}
        clearTitle={t('All time')}
        className="w-62 flex-none"
        name={{ startDate: 'startDate', endDate: 'endDate' }}
        customInputTextNode={isAllTime ? <p>{t('All time')}</p> : undefined}
        disabledRange={{ after: new Date() }}
      />
      <AdvancedFilter onSubmit={onSubmit} />
    </Form.Fields>
  );
};
